import {connect} from 'pwa-helpers';
import {LitElement, html} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {msg, str} from '@lit/localize';

import {navigator, router} from 'lit-element-router';
import {when} from 'lit/directives/when.js';
import style from '../../../../scss/profileListItem.scss';
import listStyle from '../../../../scss/list.scss';
import store from '../../store';
import {selectProfileDefaultLanguage, selectLanguage} from '../../selectors';
import {showMessage} from '../../slices/statusSlice';
import getRoutes from '../../routes';
import {profileDisplayName} from '../../util/profileDisplayName';
import {
	deselectProfile,
	selectedProfiles,
	selectProfile,
	setCurrentProfileId,
} from '../../slices/profileSlice';
import {deselectArtwork} from '../../slices/artworkSlice';

@customElement('arc-profiles-list-item')
export class ProfilesListItem extends connect(store)(router(navigator(LitElement))) {
	static styles = [listStyle, style];
	static properties = {
		profile: {type: Array},
		selectMultiple: {type: Boolean},
	};

	constructor() {
		super();
		this.profile = [];
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.lang = selectLanguage(state);
		this.currentLanguage = selectProfileDefaultLanguage(state);
		this.selectedProfiles = selectedProfiles(state);
	}
	static get routes() {
		return getRoutes();
	}
	router(route, params, query, data) {
		this.route = route;
		this.params = params;
	}

	handleSwitchProfile() {
		store.dispatch(setCurrentProfileId(this.profile.id));
		store.dispatch(
			showMessage({
				message: msg('Profile switched'),
				messageType: 'success',
			})
		);
	}

	profilePermissionDisplay(permissions) {
		if (permissions?.includes('profile/edit')) {
			return msg('edit');
		}
		if (permissions?.includes('profile/view')) {
			return msg('view');
		}
		return '';
	}
	artworkPermissionDisplay(permissions) {
		if (permissions?.includes('artwork/edit')) {
			return msg('edit');
		}
		if (permissions?.includes('artwork/view')) {
			return msg('view');
		}
		return '';
	}
	selectProfile(checked, profileId) {
		if (checked) {
			store.dispatch(selectProfile({profileId: profileId}));
		} else {
			store.dispatch(deselectProfile({profileId: profileId}));
		}
	}

	render() {
		return html`
			<div class="listItem" @click="${this.handleSwitchProfile}">
				<div class="checkbox"></div>
				<div>${this.profile.id}</div>
				<div class="title">
					${profileDisplayName(this.profile)}
					${when(this.accountId === this.profile.ownerId, () => html`(${msg('Your Profile')})`)}
				</div>
				<div>${this.profile.ownerName}</div>
				<div>${this.profile.isReadOnly ? msg('Yes') : msg('No')}</div>

				<div>${this.profile.modified}</div>
				<div>${this.profilePermissionDisplay(this.profile.permissions)}</div>
				<div>${this.artworkPermissionDisplay(this.profile.permissions)}</div>
			</div>
			<div class="listCheckbox">
				${when(
					this.selectMultiple,
					() => html`
						<arc-checkbox
							class="formInput checkbox"
							title=""
							.noFieldTitle=${true}
							.value=${this.selectedProfiles.includes(this.profile.id) ? 1 : 0}
							.showIcon=${false}
							.required=${false}
							.tooltip="${false}"
							@value-change=${(e) => this.selectProfile(e.detail.value ? 1 : 0, this.profile.id)}
						>
						</arc-checkbox>
					`
				)}
			</div>
			<div class="listButtons">
				<arc-dropdown-menu>
					<arc-button
						type="listMenu"
						title="${msg('Switch to Profile')}"
						@click=${this.handleSwitchProfile}
					>
						${msg('Switch to Profile')}
					</arc-button>
				</arc-dropdown-menu>
			</div>
		`;
	}
}
